
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-calendar" })
export default class IconCalendar extends Vue {
  sData: string = require("@icon/feather/calendar.svg");
}
